import React from 'react';
import { Link } from 'react-router-dom';

import type { ArticleOptimizationResponse } from '../../services/seoEngine';
import styles from './SeoEngineWidget.module.css';

interface SeoEngineWidgetProps {
  articleId: string;
  title: string;
  lead?: string;
  body: string;
  excerpt?: string;
  onApplyOptimization?: (result: ArticleOptimizationResponse) => void;
}

/**
 * Motor de SEO — CARD INFORMATIVO (o gatilho saiu da tela).
 *
 * O botão "Otimizar Artigo Agora" chamava POST /seo-engine/optimize e
 * SOBRESCREVIA título, resumo e corpo do editor com o que voltasse. Só que o
 * "motor" não media nem otimizava nada: as 3 variações de manchete são frases
 * fixas com o prefixo da entidade e a meta description é uma frase fixa
 * (backend/app/services/seo_engine/content_optimizer.py:115-152); ele não lê o
 * artigo além do título e não chama LLM, SERP, GSC nem WP. Os "Quality Gates
 * (Discover 2026)" que apareciam depois do clique passavam POR CONSTRUÇÃO —
 * has_meta_robots=True, has_json_ld=True e a largura mínima da imagem chegavam
 * do próprio chamador (content_optimizer.py:67-74) —, então o "Score: N / 100"
 * era um número que não mede o artigo. E nenhuma run era registrada: não existe
 * um único INSERT em article_seo_optimization no repositório, embora
 * continuous_learning.py:84-89 leia essa tabela para montar o dataset de
 * fine-tuning (que por isso sai sempre vazio).
 *
 * O código de trás CONTINUA no lugar — services/seoEngine.ts, o endpoint
 * /seo-engine/optimize e o content_optimizer não foram tocados, e o contrato
 * de props (incluindo onApplyOptimization) segue igual. Quando o motor medir de
 * verdade e persistir a run, devolver o gatilho a esta tela é reconectar o
 * botão, não reescrever a integração.
 *
 * O caminho que FLUI hoje é o de Estratégia → SEO: o sinal nasce dos dados
 * reais do Search Console, a sugestão é LLM ancorada nas queries da matéria e
 * "Aplicar no WP" grava título e meta description na matéria publicada.
 */
export const SeoEngineWidget: React.FC<SeoEngineWidgetProps> = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleGroup}>
          <h3 className={styles.title}>Motor de SEO</h3>
        </div>
      </div>

      <p className={styles.nota}>
        Correções de SEO com 1 clique vivem em{' '}
        <Link className={styles.notaLink} to="/analytics?tab=seo">
          Estratégia → SEO
        </Link>{' '}
        (sinais detectados); a otimização automática por artigo está em construção.
      </p>
    </div>
  );
};
